module.exports = {
  siteTitle: 'SmartPantry', // <title>
  manifestName: 'SmartPantry',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/images/SmartPantry-squirrel-1200x1200-191020.png',
  pathPrefix: `/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Smart Pantry',
  subHeading: "Eat it, don't waste it.",
  // social
  socialLinks: [
    // {
    //   style: 'brands',
    //   icon: 'fa-github',
    //   name: 'Github',
    //   url: 'https://github.com/anubhavsrivastava',
    // },
    // {
    //   style: 'brands',
    //   icon: 'fa-twitter',
    //   name: 'Twitter',
    //   url: 'https://twitter.com/onlyanubhav',
    // },
    {
      style: 'solid',
      icon: 'fa-envelope',
      name: 'Email',
      url: 'mailto:info@smartpantry.com'
    }
  ]
};
